'use client'

import Image from 'next/image'
import { useEffect, useState } from 'react'

const LandingBannerTransition = ({ images, interval = 4000 }: { images: string[]; interval?: number }) => {
    const [currentIndex, setCurrentIndex] = useState(0)

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentIndex(prevIndex => (prevIndex + 1) % images.length)
        }, interval)

        return () => clearInterval(timer)
    }, [images.length, interval])

    return (
        <>
            {images.map((src, index) => (
                <Image
                    key={index}
                    src={src}
                    alt={`Transition image ${index + 1}`}
                    fill
                    className={`object-contain lg:scale-110 inset-0 transition-opacity duration-1000 ease-in-out ${
                        index === currentIndex ? 'opacity-80' : 'opacity-0'
                    }`}
                />
            ))}
        </>
    )
}

export default LandingBannerTransition
